// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      welcomeMessage:"Learn for free a language with EasyLanguage",
      welcome: "Welcome to the Spanish course site",
      improve: "Improve your Spanish skills with interactive lessons and exercises.",
      availableCourses: "Available Courses",
      difficulty: "Difficulty",
      english: "English",
      spanish: "Spanish",
      chooseLanguage: "Choose your language to learn",
      grammar: "Grammar",
      availableLanguages:"Available Languages",
      siteDescription:"Everywhere, free, without limit",
      signup:"Sign up",
      login:"Login",
      logout:"Logout",
      learningTechniques:"Learning Techniques",
      learningDescription:"We use lessons-exercice technic to learn language",
      courses:"Courses",
      exercises:"Exercises",
      levelTests: "Level test",
      revisionSheets: "Revision Sheets",
      coursesDescription:"Spelling, grammar, vocabulary, audio",
      exercisesDescription:"Fun and varied exercises",
      levelTestsDescription: "Progressive testing to measure progress",
      revisionSheetsDescription: "Flashcards to quickly answer your questions",
      language:"Language",
      username:"Username",
      exercisesCompleted:"Exercises completed",
      level:"Level",
    }
  },
  fr: {
    translation: {
      welcomeMessage:"Apprends gratuitement des langues avec EasyLanguage",
      welcome: "Bienvenue sur le site de cours d'espagnol",
      improve: "Améliorez vos compétences en espagnol avec des cours interactifs et des exercices.",
      availableCourses: "Cours disponibles",
      difficulty: "Difficulté",
      english: "Anglais",
      spanish: "Espagnol",
      chooseLanguage: "Choisissez votre langue à apprendre",
      grammar: "Grammaire",
      availableLanguages:"Langues disponibles",
      siteDescription:"Partout, gratuitement, sans limite",
      signup:"Inscription",
      login:"Se connecter",
      logout:"Se déconnecter",
      learningTechniques:"Méthodes d'apprentissage",
      learningDescription:"On utilise le principe de cours -> exercices pour deviner",
      courses:"Cours",
      exercises:"Exercices",
      levelTests: "Test de niveau",
      revisionSheets: "Fiches de révision",
      coursesDescription:"Orthographe, grammaire, vocabulaire, audio",
      exercisesDescription:"Exercices ludiques et variés",
      levelTestsDescription: "Test progressif pour mesurer les progrès",
      revisionSheetsDescription: "Fiches mémotechniques pour rapidement répondre à vos questions",
      language:"Langues",
      username:"Pseudo",
      exercisesCompleted:"Exercices complétés",
      level:"Niveau",
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'fr', // Langue par défaut
  fallbackLng: 'en', // Langue de secours
  interpolation: {
    escapeValue: false, // React se charge déjà d'échapper les valeurs
  }
});

export default i18n;
